export default "__VITE_ASSET__78170650__"